<template lang="pug">
  .flow-builder-action-show-products-template
    template-tools(v-if="!disabled", @delete="$emit('delete')")
    .template-platforms-container.badges.mb-3(v-if="disabled")
      b-badge(v-for="(platform) in selectedPlatformsObjects.slice(0, sliceEnd)", :key="platform.platform_id", :style="{'background-color': platformColor(platform.name, 0.7)}") {{ platform.title }}
      b-badge(v-if="selectedPlatformsObjects.slice(sliceEnd).length", variant="soft-secondary") {{ selectedPlatformsObjects.slice(sliceEnd).length }} más
    .template-platforms-container.overflow-x.no-wrap.mb-3(v-else)
      b-form-group
        label.text-help.text-sm Plataformas donde se usará este template:
        k-select.disabled-white.flush(placeholder="- Agregar plataformas -", :options="parsedPlatforms", :disabled="disabled", :value="selected_platforms", @input="updatePlatforms", multiple, :limit="3", :searchable="false")
    b-card.mb-0.no-shadow.w-100.bg-light-white
      .bg-white
        p.mb-0 Formatear fecha
        p.text-secondary.text-sm Transforma un texto de fecha en un objeto con distintos formatos de esa fecha.
        result-description.mb-1(variable-name="_date_formated", variable-type="object")
        b-link(v-b-toggle="`doc${template_id}`")
          small Documentación
          info-icon.ml-1.icon-sm
        b-collapse.my-2(:id="`doc${template_id}`")
          ul.text-sm.text-secondary
            li day: Dia del mes
            li month: Numero de mes
            li month_string: Nombre del mes
            li year: Año
            li date_cal: Fecha en formato 'DD-MM-YYYY'
            li date_american_cal: Fecha en formato 'MM-DD-YYYY'
            li date_year_cal: Fecha en formato 'YYYY-MM-DD'
            li date_string: Fecha en formato 'DD de MMMM de YYYY'
            li hours: Horas (24Hrs)
            li minutes: Minutos
            li seconds: Segundos
            li time_12: Hora:Minutos (12Hrs ante meridiem)
            li time_24: Hora:Minutos (24Hrs)
            li date: Fecha sin formato
        fieldset.mt-1(:disabled="disabled")
          b-form-group.mb-1(label-size="sm", label="Fecha a convertir:", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'date_text'")
            vue-tribute(:options="tributeOpts")
              b-form-input(
                size="sm",
                placeholder="Fecha",
                :value="template_attribute.value",
                @blur="updateTemplateAttribute(template_attribute, $event)"
              )
</template>

<script>
import templateCommon from '@/helpers/template-common'
import TemplateTools from '@/components/templates/common/Tools.vue'
import ResultDescription from "./helpers/ResultDescription"
import _debounce from 'lodash.debounce'

export default {
  mixins: [templateCommon],
  data () {
    return {
    }
  },
  components: { TemplateTools, ResultDescription },
  created () {
    this.updateTemplateAttribute = _debounce((template_attribute, value) => {
      const attribute = JSON.parse(JSON.stringify(template_attribute))
      attribute.value = value.target._value

      this.updateAttribute(this.block_id, this.template_id, attribute).then(() => {
        this.$message.success('Actualizado')
      })
    }, 100, { leading: false, trailing: true })
  }
}
</script>

<style lang="scss" scoped>

</style>
